<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="tw-fixed tw-inset-0 tw-w-full tw-h-screen tw-flex tw-items-center tw-justify-center tw-bg-smoke-800 tw-z-50"
      @click.self="closeIfShown"
    >
      <div
        class="tw-relative tw-max-h-screen tw-w-full tw-max-w-2xl tw-bg-white tw-shadow-lg tw-rounded-lg tw-p-8 tw-flex tw-bg-kloudpurple tw-m-2 tw-rounded-3xl tw-text-kloudwhite tw-border-kloudwhite"
      >
        <button
          v-if="showClose"
          aria-label="close"
          class="tw-absolute tw-top-0 tw-right-0 tw-text-xl tw-text-kloudwhite tw-my-2 tw-mx-4"
          @click.prevent="close"
        >
          ×
        </button>
        <div class="tw-overflow-auto tw-max-h-screen tw-w-full">
          <div class="">
            <h2 class="tw-text-center tw-text-3xl tw-font-bold tw-mb-1 tw-text-kloudwhite">
              Request Quote!
            </h2>
            <p class="tw-mb-2">Complete the following for a preliminary estimate. Your final proposal will require a no-obligation network evaluation.</p>
            <div class="tw-flex tw-mb-4 tw-w-full">
              <div class="tw-w-full">
                <input :class="input_classes"  v-model="name" class="rounded" placeholder="Name">
              </div>
            </div>
            <div class="tw-flex tw-mb-4 tw-w-full">
              <div class="tw-w-full">
                <input :class="input_classes" v-model="email" class="tw-rounded" placeholder="Email">
              </div>
            </div>
            <div class="tw-flex tw-mb-4 tw-w-full">
              <div class="tw-w-full">
                <input :class="input_classes" v-model="phoneNumber" class="tw-rounded" placeholder="Phone Number">
              </div>
            </div>
            <div class="tw-flex tw-mb-4 tw-w-full">
              <div class="tw-w-full">
                <input :class="input_classes" v-model="businessType" class="tw-rounded" placeholder="Business Type">
              </div>
            </div>
            <div class="tw-flex tw-mb-4 tw-w-full">
              <div class="tw-w-full">
                <input :class="input_classes" v-model="location" class="tw-rounded" placeholder="Where are you located? (City, State)">
              </div>
            </div>
            <div class="tw-flex tw-mb-4 tw-w-full">
              <div class="tw-w-full">
                <textarea :class="input_classes" v-model="message" class="tw-rounded tw-w-full" placeholder="Message" />
              </div>
            </div>
            <div class="tw-flex tw-mb-4 tw-w-full tw-flex-row">
              <div class="tw-w-3/4">
                <label class="tw-flex tw-justify-start tw-items-start">
                  <div class="tw-bg-white tw-border-2 tw-rounded tw-border-gray-400 tw-w-6 tw-h-6 tw-flex tw-flex-shrink-0 tw-justify-center tw-items-center tw-mr-2 focus-within:tw-border-blue-500">
                    <input v-model="includeData" type="checkbox" class="absolute opacity-0">
                    <svg class="tw-fill-current tw-h-full tw-w-full tw-hidden tw-text-green-500 tw-pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z" /></svg>
                  </div>
                  <div class="tw-select-none">Submit Inputs From Calculator</div>
                </label>
              </div>
              <div class="w-1/4">
                <button class="tw-bg-kloudblue tw-grid tw-text-black tw-py-3 tw-px-5 tw-mr-0 tw-m-auto" @click.prevent="sendEmail">
                  Request Quote!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'ContactForm',
  props: {
    calcData: {
      default () { return {} },
      type: Object
    },
    value: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      showClose: true,
      backgroundClose: false,

      name: '',
      email: '',
      phoneNumber: '',
      businessType: '',
      location: '',
      message: '',
      includeData: true,
      input_classes: 'bg-white border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none text-black'
    }
  },
  computed: {
    showing () {
      return this.value
    }
  },
  watch: {
    showing (value) {
      if (value) {
        return document.querySelector('body').classList.add('overflow-hidden')
      }
      return document.querySelector('body').classList.remove('overflow-hidden')
    }
  },
  mounted () {
    if (this.showClose) {
      document.addEventListener('keydown', (e) => {
        if (e.keyCode === 27) {
          this.close()
        }
      })
    }
  },
  methods: {
    close () {
      document.querySelector('body').classList.remove('overflow-hidden')
      this.$emit('close')
    },
    closeIfShown () {
      if (this.showClose && this.backgroundClose) {
        this.close()
      }
    },
    sendEmail () {
      let calcData = {}
      if (this.includeData) {
        calcData = this.calcData
      }

      const url = 'https://www.kloudation.com/get-quote.php'
      const options = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        body: JSON.stringify({
          name: this.name,
          email: this.email,
          businessType: this.businessType,
          location: this.location,
          message: this.message,
          phoneNumber: this.phoneNumber,
          calcData
        })
      }

      fetch(url, options)


      ga('send', {
          hitType: 'event',
          eventCategory: 'Request a Quote Submits', // add any name for the category
          eventAction: 'Form Submitted', // add any name for the action
          eventLocation: 'Calculator', // add any name for the action
          hitCallback: function () {
              // alert("event sent ok");
          }
      });


      this.close()
    }
  }
}
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.6s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  input:checked + svg {
    display: block;
  }
</style>
